module.exports = __webpack_public_path__ + "img/instagram.1aa4cdf3.svg";